import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styleable from 'react-styleable';
import css from './index.scss';
import { hideToast } from './actions';

class Toast extends Component {
    constructor(props) {
        super(props);
        this.state = { isToastVisible: false, message: '' };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isToastVisible !== this.props.isToastVisible) {
            this.setState({ isToastVisible: nextProps.isToastVisible, message: nextProps.message });
            this.timeoutInstance = setTimeout(this.startTimer, 7000);
        }
    }

    startTimer=() => {
        this.setState({ isToastVisible: false, message: '' });
        if (this.props.isToastVisible) {
            this.props.hideToast();
            clearTimeout(this.timeoutInstance);
        }
    };

    hideToast=() => {
        this.setState({ isToastVisible: false, message: '' });
        this.props.hideToast();
        clearTimeout(this.timeoutInstance);
    };

    setToastColor = () => {
        const { messageType } = this.props;
        let color = '';
        switch (messageType) {
        case 'success': color = '#5cb85c';
            break;
        case 'warning': color = '#e07e02';
            break;
        default: color = '#c53902';
            break;
        }

        return color;
    }

    render() {
        const toastHtmlElement = (this.state.isToastVisible) ?
            (
                <div className={css.toast} style={{ background: this.setToastColor() }}>
                    <div className={css.message}>{this.state.message}</div>
                </div>
            ) :
            (<div className={css.empty} />);
        return toastHtmlElement;
    }
}

const mapStateToProps = state => ({
    ...state,
    isToastVisible: state.toastReducer.isToastVisible,
    message: state.toastReducer.message,
    messageType: state.toastReducer.messageType
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        hideToast
    }, dispatch);
}

Toast.propTypes = {
    message: PropTypes.string,
    isToastVisible: PropTypes.bool,
    hideToast: PropTypes.func,
    messageType: PropTypes.string
};

const StyledToast = (styleable(css)(Toast));
export default connect(mapStateToProps, mapDispatchToProps)(StyledToast);



// WEBPACK FOOTER //
// ./components/toast/index.js